import * as helper from "../helpers/WebServicesHelper";
import * as AppConfig from "../../logic/GlobalAppConfig";

const defaultTimeoutInMS = 25000;

export async function fetchInitUpload(token, dataSegmentId, fileName, fileSize, hashAlgorithm, fileHash) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return await fetch(baseUrl + "/InitUpload", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      GlobalDataSegmentId: dataSegmentId,
      FileName: fileName,
      FileSize: fileSize,
      HashAlgorithm: hashAlgorithm,
      FileHash: fileHash
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      console.log("InitUpload: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchUploadPart(token, fileId, partNo, partSize, partHash, partContent) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return await fetch(baseUrl + "/UploadPart", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      FileId: fileId,
      PartNo: partNo,
      PartSize: partSize,
      PartHash: partHash,
      PartContent: partContent
    })
  })
    .then(helper.checkStatus)
    .then(res => res.text())
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      console.log("UploadPart: " + result);
      return result;
    });
}

export async function fetchInitDownload(token, fileId) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return await fetch(baseUrl + "/InitDownload", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      FileId: fileId
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      console.log("InitDownload: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchDownloadPart(token, fileId, partNo) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return await fetch(baseUrl + "/DownloadPart", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      FileId: fileId,
      PartNo: partNo
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      console.log("DownloadPart: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchDownloadPreview(token, fileId) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return await fetch(baseUrl + "/DownloadPreview", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      FileId: fileId
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      console.log("DownloadPreview: " + JSON.stringify(json));
      return json;
    });
}

export function getWebResourceUrl(fileId) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return baseUrl + "/WebResource/" + fileId;
}

export function getProtectedWebResourceUrl(token, fileId) {
  let baseUrl = AppConfig.getBosFilesServiceUrl();
  return baseUrl + "/ProtectedWebResource/" + fileId + "?auth=" + token;
}
